import { TZDate } from 'react-day-picker';
import { navigate } from '../helpers/navigationService';
import { setCreatedNewAccount, setMemberID, setOrderCount} from '../views/member/actions/member';
import { allStepsComplete, getDefaultCheckoutStepSettings, getKioskOptions, isKioskMode, isMultiEmbed, getCollectAddressesOnFree, getSeriesConfig,getIsMailDelivery} from '../selectors/ui';
import { isReservationFree, reservationQualifiesForInsurance, reservationActive } from '../selectors/reservation';
import { setPaymentError, zeroDollarPayment } from './payment';
import { reservationCompleted, fetchReservation, sendBulkRequest, saveInsuranceOption } from './reservation';
import { scrollToTop } from '../helpers/helpers';
import { setLoading } from '../actions/loading';
import { processInsuranceResponse } from '../views/insurance/actions/insurance';
import { submitWeatherQuote } from '../views/insurance/actions/sensible-weather';
import { getAnswers } from '../selectors/questions';
import { getMemberPayload, getDeliveryPayload, getInsurancePayload, getDonationsPayload, orderRequiresNames, nameRequirementMet, getNamesPayload } from '../selectors/request';
import { getMobileDeliveryOptions, getWillCallDeliveryOptions, getEmailDeliveryOptions} from '../selectors/delivery';
import { fetchEvent } from '../actions/event';
import { PHONE_STRING_SEPARATOR } from '../views/questions/components/PhoneQuestion';
import { areAllQuestionsCompleted } from '../selectors/questions';
import { getMainEvent } from '../selectors/event';
import { mParticleIdentifyUser } from '../containers/Analytics/RoktMParticle';
import { wrappedFetch } from '../helpers/fetch';
import { getListingItem, setListingItem } from '../../listing/helpers/storage';
import { getEventTimes, selectChildEventAndContinue, setChildEventAdditionalInfo, setSelectedChildEvent, setSelectedDate } from '../views/series/actions/event-series';
import { getSeriesOption } from '../views/series/selectors/eventSeries';

const DISABLE_MARKETING_STORAGE_KEY = 'disableMarketing';

export const TIME_SLOT_OPTION_NEXT_AVAILABLE = 1;
export const TIME_SLOT_OPTION_MINUTES_HOURS_FROM_NOW = 2;

export const totalCostChange = (oldTotal, newTotal, isMailDelivery) =>
    ({ type: "TOTAL_COST_CHANGE", oldTotal, newTotal, isMailDelivery});

export function setCheckoutOverlay(overlay) {
    return {type: "CHECKOUT_OVERLAY", overlay};
}

export function removeAlert(index) {
    return {type: "REMOVE_ALERT", index};
}

export function addAlert(message, alertType = "error", dismissable = true, interpolation = {}, permanent = false) {
    scrollToTop();
    return {type: "ADD_ALERT", message, alertType, dismissable, interpolation, permanent};
}

export function clearAlerts({ clearPermanent = false } = {}) {
    return {type: "CLEAR_ALERTS", value: { clearPermanent } };
}

export function goToNextStep() {
    window.scrollTo(0, 0);
    return {type: "NEXT_STEP"};
}

export function goToPrevStep() {
    return {type: "PREV_STEP"};
}

export function goToStep(index) {
    return {type: "GO_TO_STEP", index};
}

export function setStepComplete(index, value = true) {
    return {type: "SET_STEP_COMPLETE", index, value};
}

export function setApiUrl(url) {
    return {type: "SET_API_URL", url};
}

export function setListingSlug(slug) {
    return {type: "SET_LISTING_SLUG", slug};
}

export function setListingId(id) {
  return {type: "SET_LISTING_ID", id};
}

export function stepSeen(index) {
    return {type: "CHECKOUT_STEP_SEEN", index};
}

export function ticketPickerOpened() {
    return {type: "TICKET_PICKER_OPENED"};
}

export function setCancelConfirm(value) {
    return {type: "SET_CANCEL_CONFIRM" , value};
}

export function setLanguageModal(value) {
    return {type: "SET_LANGUAGE_MODAL", value};
}

export function setShowBestAvailablePicker(val) {
    return {type: "UI_SET_SHOW_BEST_AVAILABLE_PICKER" , val};
}

export function setShowPyosPicker(val) {
    return {type: "UI_SET_SHOW_PYOS_PICKER" , val};
}

export function setUseFocusTrap(val) {
    return {type: "UI_SET_USE_FOCUS_TRAP", val};
}

export function setIsEmbed(val) {
    return {type: "UI_SET_IS_EMBED", val};
}

export function setEmbedType(val) {
    return {type: "UI_SET_EMBED_TYPE", val};
}

export function setHideBestAvailable(val) {
    return {type: "UI_SET_HIDE_BEST_AVAILABLE", val};
}

export function setDisableBestAvailable(val) {
    return {type: "UI_SET_DISABLE_BEST_AVAILABLE", val};
}

export function setBestAvailableButtonText (val) {
  return {type: "UI_SET_BEST_AVAILABLE_BUTTON_TEXT", val};
}

export function setAlwaysShowHiddenLevels (val) {
    return {type: "ALWAYS_SHOW_HIDDEN_LEVELS", val}
}

export const setIsDevMode = val => {
    return {type: 'UI_SET_IS_DEV_MODE', val};
}

export const setForceLogin = (val) => ({
    type: 'UI_SET_FORCE_LOGIN',
    val
});

export const setHasMembershipContext = (val) => ({
    type: 'UI_SET_HAS_MEMBERSHIP_CONTEXT',
    val
});

export const setMemberOnlyTicketsDeleted = (val) => ({
    type: 'UI_SET_MEMBER_ONLY_TICKETS_DELETED',
    val
});

export const membershipViewPage = () => ({
  type: 'UI_MEMBERSHIP_VIEW_PAGE',
});

export const membershipSuccessSignIn = () => ({
  type: 'UI_MEMBERSHIP_SUCCESS_SIGNIN',
});

export const membershipGoToSignIn = () => ({
  type: 'UI_MEMBERSHIP_GO_TO_SIGNIN',
});

export const membershipSignOut = () => ({
  type: 'UI_MEMBERSHIP_SIGNOUT',
});

export const continueShopping = () => ({
    type: 'UI_CONTINUE_SHOPPING',
})

export const refreshMembershipStatus = () => async (dispatch, getState) => {
    const state = getState();
    wrappedFetch(state.ui.apiUrl + `/memberships/status`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => res.json())
      .then((data) => {
        dispatch(setHasMembershipContext(data.isMemberLoggedIn));
      });
};

export const setSkipMembership = (val) => ({
    type: 'UI_SET_SKIP_MEMBERSHIP',
    val
});

export const setDisableMarketing = (val) => ({
    type: 'UI_SET_DISABLE_MARKETING',
    val,
});

// Read any previously persisted consent choice from localStorage and restore state.
export const loadDisableMarketingPreference = (listingSlug) => (dispatch) => {
    if (!listingSlug) return;

    const stored = getListingItem(listingSlug, DISABLE_MARKETING_STORAGE_KEY);
    if (stored === null) return;

    dispatch(setDisableMarketing(stored === true || stored === 'true'));
};

// Update state and persist the marketing consent choice to localStorage
export const setDisableMarketingWithPersistence = (val) => (dispatch, getState) => {
    const disable = !!val;
    dispatch(setDisableMarketing(disable));

    const listingSlug = getState()?.ui?.listingSlug;
    if (listingSlug) {
        setListingItem(listingSlug, DISABLE_MARKETING_STORAGE_KEY, disable);
    }
};

// this is specifically to process errors responded back from the server because they're in a weird format
export function addServerErrors(errors = []) {
    let messages = [];
    for(let i = 0; i < errors.length; i++) {
        messages.push(errors[i].detail);
    }

    return addAlert(messages, "error", true);
}

const formatAnswers = (answers) =>
    answers.map((answerObj) => {
        const { answer, ...rest } = answerObj;

        // Check if that's a phone number
        if (typeof answer === 'string' && answer.startsWith('+')) {
            const [code, phone] = answer.split(PHONE_STRING_SEPARATOR);

            const newAnswer = code && phone ? code + phone : '';

            return {
                ...rest,
                answer: newAnswer
            }
        }

        return answerObj;
    })

export function submitStep(step, index) {
    return (dispatch, getState) => {
        dispatch(clearAlerts());
        const state = getState();
        let requests = [];
        for(let i = 0; i < step.components.length; i++) {
            const name = step.components[i].name;

            if(name === "memberInfo" || name === "address") {
                let memberPayload = getMemberPayload(state);
                if(memberPayload) {
                    requests.push({type: 'customer', payload: memberPayload});
                }
                if(name === "address"){
                  //comp order, delivery_options lives in address.
                  let deliveryPayload = getDeliveryPayload(state);
                  if(deliveryPayload && deliveryPayload.address) {
                      requests.push({type: 'delivery_options', payload: deliveryPayload});
                  }
                }
            } else if(name === "nameOnTicket") {
                if (orderRequiresNames(state)) {
                    if (!nameRequirementMet(state)) {
                        dispatch(addAlert('checkout__must_input_name_for_each_ticket'));
                        return false;
                    }
                    requests.push({type: 'nameOnTicket', payload: getNamesPayload(state)});
                }
            } else if(name === "questions") {
                if (!areAllQuestionsCompleted(state)) {
                    dispatch(addAlert('checkout__missing_required_answer'));
                    return;
                }

                let questionPayload = formatAnswers(getAnswers(state));

                if(questionPayload.length > 0) {
                    requests.push({type: 'answers', payload: {answers: questionPayload}});
                }
            } else if(name === "delivery") {
                let deliveryPayload = getDeliveryPayload(state);
                if(deliveryPayload) {
                    requests.push({type: 'delivery_options', payload: deliveryPayload});
                }
            } else if(name === "insurance") {
                // Leaving just in case
            } else if(name === "loyaltyProgram") {
              // leaving just in case too
            } else if(name === "payment") {
                if (!state.payment.tosAccepted) {
                  dispatch(setPaymentError('tosAccepted', "Checkout__err_must_aggree_tos"));
                  return;
                }

                if(state.insurance.provider !== "") {
                  // Check if insurance provider is Protect and if isProtectClicked is not set
                  if(state.insurance.provider === "protect" &&
                     reservationQualifiesForInsurance(state) &&
                     (!state.insurance.isProtectClicked || (state.insurance.selected === "" && state.insurance.declined === false))) {
                      dispatch(addAlert("checkout__must_select_an_insurance_option"));
                      return Promise.reject();
                  }

                  if(
                      reservationQualifiesForInsurance(state) &&
                      ((state.insurance.selected === "" && state.insurance.declined === false) || (window.tg != null && ((typeof window.tg.isFormComplete === 'function' && !window.tg.isFormComplete()) && !window.tg_error)))) {
                      dispatch(addAlert("checkout__must_select_an_insurance_option"));
                      return Promise.reject();
                  }
                }

                dispatch(submitWeatherQuote());

                // no request, payment just submits itself
                document.getElementById('payment-form-invisible-button').click();
            } else if(name === "donation") {
                if (state.donations.hasDonations) {
                    requests.push({type: 'donation', payload: {donations: getDonationsPayload(state)}});
                }
            } else if (name === 'weather') {
              const quoteId = document.getElementById('sensible-weather-quote')?.value ?? 0;
              if (quoteId) {
                const swSelected = document.getElementById('sensible-weather-selected')?.value ?? false;
                const quotePrice = document.getElementById('sensible-weather-price-charged')?.value ?? 0;
                requests.push({type: 'weather', payload: {id: quoteId, status: swSelected === 'true', price: quotePrice}});
              }
            }
        }

        if(requests.length > 0) {
            dispatch(setLoading("CHECKOUT_STEP_REQUEST"));
            return dispatch(sendBulkRequest(requests)).then((res) => {

                let state = getState();

                if(res?.customer && res.customer.errors) {
                    throw res.customer.errors;
                }

                if(res?.answers && res.answers.errors) {
                    throw res.answers.errors;
                }

                if(res?.delivery_options && res.delivery_options.errors) {
                    throw res.delivery_options.errors;
                }

                if(res?.insurance) {
                    processInsuranceResponse(dispatch, state, res.insurance);
                }

                if (res?.donation && res.donation.errors) {
                    throw res.donation.errors;
                }

                if (res?.nameOnTicket && res.nameOnTicket.errors) {
                    throw res.nameOnTicket.errors;
                }

                if (res?.customer && res.customer.attributes ) {
                  if (res.customer.attributes.hasOwnProperty('created_new_account')){
                    const createdNewAccount = res.customer.attributes.created_new_account ? true : false;
                    dispatch(setCreatedNewAccount(createdNewAccount));
                  }
                  dispatch(setMemberID(res.customer.attributes.user_id));
                  dispatch(setOrderCount(res.customer.attributes.order_count));
                  if (res.customer.attributes?.email) {
                    mParticleIdentifyUser(res.customer.attributes.email);
                  }
                }

                dispatch(setStepComplete(index, true));
                fetchReservation(state.reservation.token, state.reservation.secret)(dispatch, getState).then(() => {
                    state = getState();
                    if(allStepsComplete(state) && isReservationFree(state)) {
                        zeroDollarPayment()(dispatch, getState).then((result) => {
                            dispatch(goToConfirmation());
                            dispatch(setLoading("CHECKOUT_STEP_SUCCESS"));
                        }).catch(error => {
                            dispatch(setLoading("CHECKOUT_STEP_FAILURE"));
                            // error should already be displayed, the substeps should add their own alerts
                        });
                    } else {
                        dispatch(setLoading("CHECKOUT_STEP_SUCCESS"));
                        dispatch(goToNextStep());
                        dispatch(stepSeen(state.ui.currentStep + 1));
                    }
                });
            }).catch((errors) => {
                dispatch(setLoading("CHECKOUT_STEP_FAILURE"));
                dispatch(addServerErrors(errors));
            });
        }

    }
}

export function goToConfirmation(pending = false, token = null) {
    return (dispatch, getState) => {
        let state = getState();
        if (pending) {
            // SCX-11513: pending reservations complete server-side later, so no purchase
            // event is dispatched to analytics here; record that for gap investigations
            if (typeof Rollbar !== 'undefined') {
                Rollbar.info('Reservation entered pending payment state; purchase event deferred', JSON.stringify({
                    params: {
                        isEmbed: state.ui.isEmbed,
                    },
                }));
            }
            navigate(`/pending/${ token }`);
        } else {
            dispatch(reservationCompleted());
            navigate(`/confirmation/${state.reservation.confirmation_number}`);
        }
        dispatch(triggerConfirmation());
        if (isKioskMode(state)) {
            dispatch(fetchEvent());
        }
    }
}

export function goToListing() {
    return (dispatch) => {
        dispatch(setCheckoutOverlay(false));
        dispatch(setConfirmation(false));
        navigate('/')
    }
}

export function triggerConfirmation() {
    return {type: "GO_TO_CONFIRMATION"};
}

export function setStepStatus(stepType, complete) {
    return {type: "SET_STEP_STATUS", stepType, complete};
}

export function setConfirmation(confirmation) {
    return {type: "SET_CONFIRMATION", confirmation};
}

export function setListingConfig(listingConfig) {
    listingConfig = processConfig(listingConfig);

    return {type: "SET_LISTING_CONFIG", listingConfig};
}



/**
 * update checkout steps to default maintaining the complete flag on the current checkout steps
 * @param  state - the current state of the redux store
 */
export function refreshCheckoutSteps(state) {
    const config = state.ui && state.ui.listingConfig ? state.ui.listingConfig : null;
    const questions = state.questions;

    if (config && config.checkoutSteps && Array.isArray(config.checkoutSteps)) {
        //get current step statuses
        let stepStatuses = {};
        config.checkoutSteps.forEach(step => {
            if (Object.keys(step).indexOf('complete') !== -1 && Object.keys(stepStatuses).indexOf(step.title) === -1) {
                stepStatuses[step.title] = step.complete;
            }
        });

        //get default checkout steps and apply step statuses
        let hasQuestions = Object.keys(questions.events).length !== 0 || questions.orders.length !== 0;

        const requiresNameOnTicket = orderRequiresNames(state);;

        let hasDeliveryOptions = false;

        if (isKioskMode(state)) {
            const kioskOptions = getKioskOptions(state);
            const hasMobile = kioskOptions.allowMobileDelivery && getMobileDeliveryOptions(state).length;
            const hasWillCall = kioskOptions.allowWillCallDelivery && getWillCallDeliveryOptions(state).length;
            const hasEmail = kioskOptions.allowEmailDelivery && getEmailDeliveryOptions(state).length;
            hasDeliveryOptions = hasMobile || hasWillCall || hasEmail;
        } else {
            hasDeliveryOptions = state.delivery.options.length ? true : false;
        }

        const isFree = isReservationFree(state);
        const collectAddressesOnFree = getCollectAddressesOnFree(state);
        const isMailDelivery = getIsMailDelivery(state);
        let checkoutSteps = getDefaultCheckoutStepSettings(config, {
          hasQuestions,
          hasDeliveryOptions,
          requiresNameOnTicket,
          isFree,
          collectAddressesOnFree,
          isMailDelivery
        });

        if (checkoutSteps && Array.isArray(checkoutSteps)) {
            checkoutSteps.forEach((step, key) => {
                if (Object.keys(stepStatuses).indexOf(step.title) !== -1) {
                    checkoutSteps[key].complete = stepStatuses[step.title];
                }
            });
        }

        //update checkout steps and dispatch
        config.checkoutSteps = checkoutSteps;
        return {type: "SET_LISTING_CONFIG", listingConfig: config};
    }
}

export function resetUi() {
    return {type: "RESET_UI"};
}

export function setCheckoutConfig(config) {
    return {type: "SET_CHECKOUT_CONFIG", config};
}

export function setDefaultShowCalendarInModal(value) {
    return {type: "SET_DEFAULT_SHOW_CALENDAR_IN_MODAL", value};
}

export function setShowCalendarInModal(value) {
    return {type: "SET_SHOW_CALENDAR_IN_MODAL", value};
}

export function setInteractionBlock(value) {
    return {type: "SET_INTERACTION_BLOCK", value};
}

export function setCurrentMonth(value, subReducerKey = null) {
    return {type: "SET_CURRENT_MONTH", value, subReducerKey};
}

function processConfig(config) {
    config.checkoutSteps = getDefaultCheckoutStepSettings(config);
    return config;
}

export function setPaymentHandlesSubmission(value) {
    return {type: "SET_PAYMENT_HANDLES_SUBMISSION", value};
}

export function setMaintenanceMode(value) {
    return {type: "SET_MAINTENANCE_MODE", value};
}

export function setRouteName(value) {
    return {type: "router/SET_CURRENT_ROUTE_NAME", value};
}

export const trySelectDefaultTimeSlot = (dateString) => {
  return async (dispatch, getState) => {
    const state = getState();
    const eventId = getMainEvent(state)?.event?.event_id ?? null;
    const timezone = getMainEvent(state)?.venue?.address?.timezone || '';
    const { isDefaultTodayEnabled, isDefaultTimeSlotEnabled, defaultTimeSlotOption, defaultTimeSlotTimeOffset } = getSeriesConfig(state);

    if (!eventId || !isDefaultTodayEnabled || !isDefaultTimeSlotEnabled) {
      return;
    }

    if (dateString) {
      await dispatch(getEventTimes(eventId, dateString));
    }

    const now = TZDate.tz(timezone);

    let comparisonTime;

    if (defaultTimeSlotOption === TIME_SLOT_OPTION_NEXT_AVAILABLE) {
      comparisonTime = now;
    } else if (defaultTimeSlotOption === TIME_SLOT_OPTION_MINUTES_HOURS_FROM_NOW) {
      comparisonTime = new TZDate(now.getTime() + Number(defaultTimeSlotTimeOffset) * 60000, timezone);
    } else {
      return;
    }

    const updatedState = getState();

    const nextAvailableTimeSlot = updatedState.eventSeries.eventTimes.find((timeSlot) => {
      const timeSlotDate = new TZDate(new Date(timeSlot.time), timezone);
      return timeSlotDate > comparisonTime;
    });

    if (nextAvailableTimeSlot) {
      dispatch(setSelectedChildEvent(Number(nextAvailableTimeSlot.id)));
      dispatch(setChildEventAdditionalInfo(nextAvailableTimeSlot.childEventAdditionalInfo));
      dispatch(selectChildEventAndContinue(Number(nextAvailableTimeSlot.id), false));
    }
  }
}

export const trySelectDefaultDate = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const { isDefaultTodayEnabled } = getSeriesConfig(state);
    const calendarType = getSeriesOption("calendarType")(state);
    const isListOnly = calendarType === 'list';

    if (!isDefaultTodayEnabled || isListOnly) {
      return;
    }

    const eventId = getMainEvent(state)?.event?.event_id ?? null;
    const timezone = getMainEvent(state)?.venue?.address?.timezone || '';
    const eventDates = [...Object.values(state.event.events)?.[0]?.event?.series?.eventDates || []];

    const today = TZDate.tz(timezone);

    const hasEventToday = eventDates.some((eventDate) => {
      const date = new TZDate(eventDate, timezone);

      const isSameYear = date.getUTCFullYear() === today.getUTCFullYear();
      const isSameMonth = date.getUTCMonth() === today.getUTCMonth();
      const isSameDay = date.getUTCDate() === today.getUTCDate();

      return isSameYear && isSameMonth && isSameDay;
    });

    if (!hasEventToday) {
      return;
    }

    dispatch(setSelectedChildEvent(null));
    dispatch(setChildEventAdditionalInfo(""));
    dispatch(setShowCalendarInModal(true));
    const dateString = await dispatch(setSelectedDate(today));
    await dispatch(getEventTimes(eventId, dateString, null, null, false, true));
    dispatch(trySelectDefaultTimeSlot());
  }
}

export const startCheckout = (showCheckoutCallback = null) => {
    return (dispatch, getState) => {
        // Lazy require to avoid circular dependency
        const { autoApplyAccessCode } = require('../views/coupon/actions/coupon');

        const mainEvent = getMainEvent(getState())?.event;
        const priceLevels = getState().priceLevel.levels;
        const activeMembership = !!getState()?.ui?.uiConfig?.membershipFormConfig;
        const selectedChildEvent = getState().event?.childEvent?.event;
        if (mainEvent?.isRecurring) {
          //setting checkout overlay handled in transition for seriesDatePicker
          dispatch(trySelectDefaultDate());
          dispatch(setCheckoutOverlay(true));
          navigate('/day');
        } else if (
          (!mainEvent?.isOnsale &&
            mainEvent?.hasPresale &&
            Object.keys(priceLevels).length === 0 &&
            getState().coupon.isPresaleCodeApplied === false) ||
          (mainEvent?.hasPlAccess === true && Object.keys(priceLevels).length === 0)
        ) {
          const couponState = getState().coupon;
          if (couponState.accessCode && couponState.isAccessCodeApplied === true) {
            dispatch(setCheckoutOverlay(true));
            dispatch(autoApplyAccessCode(couponState.accessCode));
            return;
          }
          // presale or no PLs available w/o access code
          dispatch(setCheckoutOverlay(true));
          navigate('/promo');
        } else {
          // clear out previous selection
          dispatch(setShowBestAvailablePicker(false));
          dispatch(setShowPyosPicker(false));

          dispatch(setCheckoutOverlay(true));
          dispatch(ticketPickerOpened());

          const couponState = getState().coupon;
          if (mainEvent?.hasPlAccess === true && couponState.accessCode && couponState.isAccessCodeApplied === true) {
            dispatch(autoApplyAccessCode(couponState.accessCode));
          }

          if (isMultiEmbed(getState())) {
            navigate('/picker-with-details');
          } else if (getState().dynamicListing.isDynamicListing) {
            navigate(mainEvent?.isRecurring ? '/day' : '/');
          }

          if (typeof showCheckoutCallback === 'function') {
            showCheckoutCallback();
          }
        }
    }
}

export const focusOnOrgListingButton = () => {
  return (_, getState) => {
    const listingId = getState().ui.listingId;

    const listingButton = window.top.document.getElementById(`listing-item__button-${listingId}`);
    listingButton?.focus();
  }
}
